import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMsanGray = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 448 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 32H214.6V246.6H0V32ZM233.4 32H448V246.6H233.4V32ZM0 265.4H214.6V480H0V265.4ZM233.4 265.4H448V480H233.4V265.4Z",
		fill: "#B3B3BB"
	})
});
export default SvgMsanGray;
